import React from "react";
import { Input, Label } from "reactstrap";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
import _ from "lodash";
// Used by the DP5, Duro, Heli KV2008B, Heli KV2019B, M50, Mahan Dryer,
// Mahan Oven, Saurer TC2, SSM Kingspool, UT50/60, Xeno, and Xorella machines

export default function RadioLabelCol({
   groupNameProp,
   valueProp,
   onChangeProp,
   displayProp,
   trueFalseProp,
   stringProp,
}) {
   const { onChange, onChangeErrorDivDefinitions } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();

   if (trueFalseProp) {
      const realValue = valueProp === "true" ? true : valueProp === "false" ? false : null;
      return (
         <Label className="me-2">
            <Input
               type="radio"
               name={groupNameProp}
               value={valueProp}
               onChange={(e) => {
                  onChange(`extendedPropertyJson.${onChangeProp}`, e.target.value);
                  if (errorDivDefinitions?.[onChangeProp])
                     onChangeErrorDivDefinitions(onChangeProp, false);
               }}
               checked={
                  machineSetup.extendedPropertyJson?.[onChangeProp] === valueProp ||
                  machineSetup.extendedPropertyJson?.[onChangeProp] === realValue
               }
            />
            {displayProp}
         </Label>
      );
   } else if (stringProp) {
      const realValue = _.toString(valueProp);
      return (
         <Label className="me-2">
            <Input
               type="radio"
               name={groupNameProp}
               value={valueProp}
               onChange={(e) => {
                  onChange(`extendedPropertyJson.${onChangeProp}`, e.target.value);
                  if (errorDivDefinitions?.[onChangeProp])
                     onChangeErrorDivDefinitions(onChangeProp, false);
               }}
               checked={
                  machineSetup.extendedPropertyJson?.[onChangeProp] === valueProp ||
                  machineSetup.extendedPropertyJson?.[onChangeProp] === realValue
               }
            />
            {displayProp}
         </Label>
      );
   } else {
      return (
         <Label className="me-2">
            <Input
               type="radio"
               name={groupNameProp}
               value={valueProp}
               onChange={(e) => {
                  onChange(`extendedPropertyJson.${onChangeProp}`, e.target.value);
                  if (errorDivDefinitions?.[onChangeProp])
                     onChangeErrorDivDefinitions(onChangeProp, false);
               }}
               checked={
                  machineSetup.extendedPropertyJson?.[onChangeProp] === valueProp
               }
            />
            {displayProp}
         </Label>
      );
   }
}
